module.exports = __webpack_public_path__ + "static/media/adrian-iurov.e8155790.jpg";